import React from 'react';
import { SearchInput } from '@features/SearchInput';
import { usePaymentRequestsTable } from '../../lib';
import { DateSelect } from '@shared/UI';
import './PaymentRequestsTableFilters.scss';
import { formats } from '@shared/utils';

export const PaymentRequestsTableFilters: React.FC = () => {
    const { date, setDate, setSearch } = usePaymentRequestsTable();

    return (
        <div className='widget-payment-requests-table-filters'>
            <SearchInput
                setValue={setSearch}
                queryName='search'
                placeholder='Account Number'
            />
            <DateSelect
                currentValue={date}
                format={formats.dateWithYear}
                allowClear
                placeholder='Date'
                onDateSelect={(date) => setDate(date)}
            />
        </div>
    );
};
